<template>
  <div class="product-details-content-setup-step-03">
    <snow-switch
      v-model="form.certificate_enabled"
      class="mb-4"
      :label="
        'Certificado ' + (form.certificate_enabled ? 'ativado' : 'desativado')
      "
      info="Você pode desativar e ativar seu certificado a qualquer momento, sem
      perder os dados salvos."
    />
    <div class="row">
      <div class="col-lg-8">
        <h5 class="text-semibold">
          Porcentagem de conclusão do curso para emissão do certificado
        </h5>
        <small class="text-secondary">
          Decida qual porcentagem de conteúdo e de avaliação deverão ser
          concluídos para liberação de certificado na sua área de membros.
        </small>
        <div class="d-flex align-items-center gap-4">
          <small>{{ form.minimum_content_progress || 0 }}%</small>
          <b-form-input
            id="conclusion-range"
            class="mt-4"
            :min="1"
            :max="100"
            type="range"
            v-model="form.minimum_content_progress"
          />
          <small>100%</small>
        </div>
      </div>
    </div>
    <div class="warning-card">
      <i class="ph ph-warning-circle" />
      <div class="d-flex flex-column">
        <h5>Atenção</h5>
        <small class="text-dark-40 fs-12">
          Recomendamos a configuração de 100% para conteúdo. Assim, seu aluno
          terá que concluir todas as aulas para garantir a liberação do
          certificado
        </small>
      </div>
    </div>

    <snow-switch
      v-if="form.certificate_enabled"
      v-model="rating_enabled"
      label="Incluir avaliações para emissão do certificado"
    />

    <div v-if="rating_enabled && form.certificate_enabled">
      <div class="row">
        <div class="col-lg-8">
          <h5 class="text-semibold mb-4">
            Avaliações
          </h5>
          <div class="d-flex align-items-center gap-4">
            <small>{{ form.minimum_quiz_progress || 0 }}%</small>
            <b-form-input
              class="mb-4"
              id="conclusion-range"
              :min="1"
              :max="100"
              type="range"
              v-model="form.minimum_quiz_progress"
            />
            <small>100%</small>
          </div>
        </div>
      </div>
      <div class="warning-card">
        <i class="ph ph-warning-circle" />
        <div class="d-flex flex-column">
          <h5>Atenção</h5>
          <small class="text-dark-40 fs-12">
            Recomendamos a configuração de 100% para avaliações. Assim, seu
            aluno terá que concluir todas as avaliações para garantir a
            liberação do certificado
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    rating_enabled: {
      get() {
        return !!this.form.minimum_quiz_progress;
      },
      set(v) {
        this.form.minimum_quiz_progress = v ? 100 : 0;
        return v;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.product-details-content-setup-step-03 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  input[type="range"] {
    &::-webkit-slider-thumb {
      background: var(--light);
      box-shadow: (0 2px 8px rgba(0, 0, 0, 0.2));
      margin-top: -10px;
      height: 24px;
      width: 24px;
    }
    &::-moz-range-thumb {
      background: var(--light);
      box-shadow: (0 2px 8px rgba(0, 0, 0, 0.2));
      margin-top: -10px;
      height: 24px;
      width: 24px;
    }
    &::-webkit-slider-runnable-track {
      background: var(--dark-4);
      height: 3px;
      border-radius: 4px;
    }
    &::-moz-range-track {
      background: var(--dark-4);
      height: 3px;
      border-radius: 1.5px;
    }
  }
}
</style>
